var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7499 22.75H8.24992C3.27242 22.75 1.14575 20.43 1.14575 15V9C1.14575 3.57 3.27242 1.25 8.24992 1.25H12.8333C13.2091 1.25 13.5208 1.59 13.5208 2C13.5208 2.41 13.2091 2.75 12.8333 2.75H8.24992C4.02409 2.75 2.52075 4.39 2.52075 9V15C2.52075 19.61 4.02409 21.25 8.24992 21.25H13.7499C17.9758 21.25 19.4791 19.61 19.4791 15V10C19.4791 9.59 19.7908 9.25 20.1666 9.25C20.5424 9.25 20.8541 9.59 20.8541 10V15C20.8541 20.43 18.7274 22.75 13.7499 22.75Z",
    fill: "#8DC63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1666 10.7505H16.4999C13.3649 10.7505 12.1458 9.42048 12.1458 6.00048V2.00048C12.1458 1.70048 12.3108 1.42048 12.5674 1.31048C12.8241 1.19048 13.1174 1.26048 13.3191 1.47048L20.6524 9.47048C20.8449 9.68048 20.9091 10.0105 20.7991 10.2905C20.6891 10.5705 20.4416 10.7505 20.1666 10.7505ZM13.5208 3.81048V6.00048C13.5208 8.58048 14.1349 9.25048 16.4999 9.25048H18.5074L13.5208 3.81048Z",
    fill: "#8DC63F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 13.75H6.41675C6.04091 13.75 5.72925 13.41 5.72925 13C5.72925 12.59 6.04091 12.25 6.41675 12.25H11.9167C12.2926 12.25 12.6042 12.59 12.6042 13C12.6042 13.41 12.2926 13.75 11.9167 13.75Z",
    fill: "#8DC63F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0834 17.75H6.41675C6.04091 17.75 5.72925 17.41 5.72925 17C5.72925 16.59 6.04091 16.25 6.41675 16.25H10.0834C10.4592 16.25 10.7709 16.59 10.7709 17C10.7709 17.41 10.4592 17.75 10.0834 17.75Z",
    fill: "#8DC63F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/DocumentText.41b118812f40dfabd30cf3695dd91eb5.svg";
export { ForwardRef as ReactComponent };